import React, { useState } from "react";
import confs from "../../../configurations";
import { navigate } from "../../../routes";
import { admin } from "../../../routes/admin";
import sdk from "../../../sdk/sdk";
import { useAuth } from "../../Auth/useAuth";
import { useCart } from "../../Carts/useCart";
import { useAPIManager } from "../../lib/APIManager";
import useTranslations from "../../Translations/useTranslations";
import UiButton from "../../ui/UiButton";

function BasketBuilder({ isCartCreating = () => {}, disabled = false }) {
  const { URL_API } = confs;
  const trl = useTranslations();
  const [isCreatingCart, setCartCreationProcessing] = useState(false);
  const [{ user }, { isRoleOperator }] = useAuth();
  const [carts, cartsMethods, isCartsLoaded] = useCart(user.client_profile?.id);
  const [clients, clientsMethods] = useAPIManager({
    baseUrl: URL_API,
    ressource: {
      name: "clients",
      key: "CODCLI",
    },
    defaultHeaders: {
      "Content-type": "application/json",
      Authorization: (state) => state.auth && "Bearer " + state.auth.token,
    },
  });

  function buttonLabel() {
    const val = trl.message("HomePage.newCartAction");
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const getItemAsync = (userId) => {
    return new Promise((resolve, reject) => {
      clientsMethods.getItem(userId, null, (err, item) => {
        if (err) {
          reject(err);
        } else {
          resolve(item);
        }
      });
    });
  };

  const onClick = async (e) => {
    if (isRoleOperator() && !user?.client_profile?.id) {
      navigate.push(admin.NEW_CART);
      return;
    }

    if (!isCreatingCart) {
      setCartCreationProcessing(true);
      isCartCreating(true);
      try {
        const item = await getItemAsync(user.client_profile?.id, null);

        const data = await sdk.orders.saveCartDB(user.client_profile?.id, {});

        // Create the cart
        await cartsMethods.createCart({
          client: item,
          id: data.payload.header.id,
          creator: item?.CODCLI,
        });

        // Navigate to the admin page
        navigate.push(admin.APP_NAVIGATION, {
          critere: "start",
        });
      } catch (err) {
        console.error("Error saving cart:", err);
      } finally {
        setCartCreationProcessing(false);
        isCartCreating(false);
      }
    }
  };

  return (
    <React.Fragment>
      <UiButton
        onClick={onClick}
        content={isCreatingCart || !isCartsLoaded ? "Chargement..." : buttonLabel()}
        disabled={isCreatingCart || disabled || !isCartsLoaded} // Disable the button while the cart is being created or externally disabled
      />
    </React.Fragment>
  );
}

export default BasketBuilder;
